import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import { LegalPage } from '../../Common/HelpCenter';
import { TERMS_TITLE, TERMS_SECTIONS } from '../../Common/HelpCenter/legalContent';

const CLSDKTermsConditions = () => (
  <LegalPage
    brand="CLS"
    header={<Header showTopBar={false} />}
    footer={<Footer />}
    title={TERMS_TITLE}
    sections={TERMS_SECTIONS}
  />
);

export default CLSDKTermsConditions;
